import React, { useState } from 'react';
import { NeoModal, NeoButton, NeoInput } from '../../../../components/Common';

const OpenCashierModal = ({ isOpen, toggle, onConfirm, isProcessing }) => {
    const [openingBalance, setOpeningBalance] = useState(0);

    const handleConfirm = () => {
        onConfirm({
            idBankAccount: "default",
            openingBalance: Number(openingBalance)
        });
    };

    return (
        <NeoModal
            isOpen={isOpen}
            toggle={toggle}
            title="Abertura de Caixa"
            subtitle="Inicie um novo turno de trabalho"
            headerIcon="mdi-cash-register"
            footerActions={
                <>
                    <NeoButton 
                        variant="secondary"
                        onClick={toggle} 
                        disabled={isProcessing}
                    >
                        Cancelar
                    </NeoButton>
                    <NeoButton 
                        variant="primary"
                        onClick={handleConfirm}
                        disabled={isProcessing} 
                        loading={isProcessing}
                    >
                        Abrir Caixa
                    </NeoButton>
                </>
            }
        >
            <p className="text-muted mb-4 font-size-13" style={{ lineHeight: "1.4" }}>
                O processo de abertura marca o início de um novo turno de trabalho. 
                Defina com qual saldo inicial (fundo de troco) você está começando.
            </p>

            <div className="mb-0">
                <label 
                    className="font-size-11 text-muted fw-bold mb-2 text-uppercase d-block"
                    style={{ letterSpacing: "0.5px" }}
                >
                    Fundo de Troco Inicial (R$)
                </label>
                <NeoInput
                    id="opening-balance-input"
                    name="openingBalance"
                    type="number"
                    placeholder="0,00"
                    min="0"
                    step="0.01"
                    value={openingBalance}
                    onChange={(e) => setOpeningBalance(e.target.value || 0)}
                    autoComplete="off"
                    size="md"
                    inputStyle={{ textAlign: 'right', fontWeight: 'bold' }}
                />
                <small className="text-muted d-block mt-2 font-size-11">Este valor representa as cédulas já presentes na gaveta antes de qualquer venda.</small>
            </div>
        </NeoModal>
    );
};

export default OpenCashierModal;
